export default __webpack_public_path__ + "static/media/1.2821e9d5.png";